/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

const AustriaSpeceficHeader = ({
  locale,
  fiscalDocuments
}) => {
  const {
    RL_ReferenceNumber, RL_CertificateNumber
  } = useSelector((state) => state);

  if (locale !== 'de-AT' || !fiscalDocuments?.length) return <></>;

  const { DocumentNo, DocumentId } = fiscalDocuments[0];
  return (
    <>
      {DocumentNo && (
        <article className="justify-between">
          <p>{`${RL_ReferenceNumber}: ${DocumentNo}`}</p>
        </article>
      )}
      {DocumentId && (
        <article className="justify-between">
          <p>{`${RL_CertificateNumber}: ${DocumentId}`}</p>
        </article>
      )}
      {(DocumentNo || DocumentId) && <><br /><br /></>}
    </>
  );
};

AustriaSpeceficHeader.defaultProps = {
  fiscalDocuments: []
};

AustriaSpeceficHeader.propTypes = {
  fiscalDocuments: PropTypes.arrayOf(PropTypes.shape({
    DocumentId: PropTypes.string,
    DocumentNo: PropTypes.string,
  })),
  locale: PropTypes.string.isRequired
};

export default AustriaSpeceficHeader;
